import { parseAddressString } from './parse-address-string';

/** Formats the locality portion of an Australian address as city, state postcode. */
export function toAddressLocation(value: string): string {
    const parsed = parseAddressString(value);
    const region = [parsed.stateCode, parsed.postcode]
        .filter(Boolean)
        .join(' ');
    const locality = resolveLocality(value, parsed);

    return [locality, region].filter(Boolean).join(', ');
}

function resolveLocality(
    value: string,
    parsed: ReturnType<typeof parseAddressString>
): string {
    const parts = value
        .split(',')
        .map((part) => part.trim().replace(/\s+/g, ' '))
        .filter(Boolean);
    if (
        parts.length === 2 &&
        !parsed.streetNumber &&
        (parsed.stateCode || parsed.postcode)
    ) {
        return parts[0] ?? '';
    }

    if (parsed.suburb) {
        return !parsed.streetNumber && parsed.streetName && !value.includes(',')
            ? `${parsed.streetName} ${parsed.suburb}`
            : parsed.suburb;
    }

    if (!parsed.stateCode && !parsed.postcode) return '';
    if (!parsed.streetNumber && parsed.streetName) return parsed.streetName;

    return '';
}
